import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  StyledReferralCard,
  StyledReferralCardCityInfo,
  StyledReferralCardCityInfoDescription,
  StyledReferralCardCityInfoTitle,
  StyledReferralCardMainInfo,
  StyledReferralCardMainInfoDate,
  StyledReferralCardMainInfoStatus,
  StyledReferralCardMainInfoUsername,
} from './ReferralCard.styles';
import { IReferralCardProps } from './ReferralCard.types';

const ReferralCard = ({
  name,
  status,
  date,
  city,
}: IReferralCardProps): JSX.Element => {
  const { t } = useTranslation(['common', 'referralStatus']);

  return (
    <StyledReferralCard>
      <StyledReferralCardMainInfo>
        <StyledReferralCardMainInfoUsername>
          {name}
        </StyledReferralCardMainInfoUsername>
        <StyledReferralCardMainInfoStatus status={status}>
          {upperFirst(t(`referralStatus:${status}`))}
        </StyledReferralCardMainInfoStatus>
        <StyledReferralCardMainInfoDate>
          {date.split('-').reverse().join('/')}
        </StyledReferralCardMainInfoDate>
      </StyledReferralCardMainInfo>
      <StyledReferralCardCityInfo>
        <StyledReferralCardCityInfoTitle>
          {upperFirst(t('common:city'))}
        </StyledReferralCardCityInfoTitle>
        <StyledReferralCardCityInfoDescription>
          {upperFirst(city)}
        </StyledReferralCardCityInfoDescription>
      </StyledReferralCardCityInfo>
    </StyledReferralCard>
  );
};

export default ReferralCard;
